import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Authenticity } from './pages/Authenticity';
import { CrewRewards } from './pages/CrewRewards';
import { Activate } from './pages/Activate';
import { Guide } from './pages/Guide';
import { OwnerCenter } from './pages/OwnerCenter';
import { TrackOrder } from './pages/TrackOrder';
import { ScrollToHash } from './components/ScrollToHash';
import { PixelRouteTracker } from './components/PixelRouteTracker';
import { SiteMeta } from './components/SiteMeta';
import { ShopifyAnalytics } from './components/ShopifyAnalytics';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}

// Loads the Meta Pixel and fires PageView the moment the site's code loads, before
// anything renders, so no visit is missed and later events (ViewContent) always find it.
initPixels();
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3mkhmvvd9p66k">
      <ScrollToHash data-id="element-1" data-mp="3mjztd6hzp62c" />
      <PixelRouteTracker data-id="element-2" data-mp="3mj6ibtbzzuee" />
      <ShopifyAnalytics data-id="element-3" data-mp="3rcj31sdk3h1v" />
      <SiteMeta data-id="element-4" data-mp="3rdaselgk8ijp" />
      <Routes data-id="element-5" data-mp="3rcsw5otwe4bs">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-7" data-mp="6hq1ea16ddl" />} data-id="element-6" data-mp="3recf5n6xuth9" />
        <Route path="/verify" element={<Authenticity data-id="element-9" data-mp="2zmenc70qri6z" />} data-id="element-8" data-mp="2zllduyaeeel5" />
        <Route path="/rewards" element={<CrewRewards data-id="element-11" data-mp="33mf0zpg0npcz" />} data-id="element-10" data-mp="2zn6bwxvx8fnr" />
        <Route path="/activate" element={<Activate data-id="element-13" data-mp="33myix65o2dr0" />} data-id="element-12" data-mp="33nq4do5juv3k" />
        <Route path="/owner" element={<OwnerCenter data-id="element-15" data-mp="38li8dgjgy7o4" />} data-id="element-14" data-mp="38lro8basuyg3" />
        <Route path="/guide" element={<Guide data-id="element-17" data-mp="38o4fxg6d0n6c" />} data-id="element-16" data-mp="38k6u2msedhir" />
        <Route path="/track" element={<TrackOrder data-id="element-19" data-mp="3dlw5w4ng1z7w" />} data-id="element-18" data-mp="3dkl4ucldv5kh" />
        <Route path="/legal/:slug" element={<Legal data-id="element-21" data-mp="nvj3jfxq0epq" />} data-id="element-20" data-mp="3dm5ylzzvikha" />
        <Route path="*" element={<Legal data-id="element-23" data-mp="nur6e0oh68xc" />} data-id="element-22" data-mp="nw2e2bl1k0tq" />
      </Routes>
    </BrowserRouter>;
}